import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Search, Megaphone, Briefcase } from "lucide-react";

export default function PuneHub() {
  const nav = useNavigate();
  return (
    <div className="gs-fade">
      <div className="bg-gradient-to-br from-yellow-400 to-amber-500 text-white px-4 pt-3 pb-6 rounded-b-3xl">
        <button data-testid="back-button" onClick={() => nav("/")} className="p-1.5 -ml-1 mb-2 rounded-full bg-white/20"><ArrowLeft className="w-5 h-5" /></button>
        <div className="flex items-center gap-2"><Briefcase className="w-7 h-7" /><h1 className="text-2xl font-extrabold">Punë</h1></div>
        <p className="text-white/90 text-sm mt-1">Gjej punë ose gjej punëtorë.</p>
      </div>

      <div className="px-4 mt-5 space-y-4">
        <button data-testid="hub-kerko-pune" onClick={() => nav("/kerko-pune")} className="w-full bg-white rounded-3xl border border-slate-100 shadow-sm p-6 text-left hover:-translate-y-0.5 transition-all">
          <div className="w-14 h-14 rounded-2xl bg-emerald-100 flex items-center justify-center mb-3"><Search className="w-7 h-7 text-emerald-600" /></div>
          <div className="text-xl font-extrabold text-slate-900">🔎 Kërko Punë</div>
          <p className="text-sm text-slate-500 mt-0.5">Jam duke kërkuar punë</p>
        </button>

        <button data-testid="hub-publiko-pune" onClick={() => nav("/jep-pune")} className="w-full bg-white rounded-3xl border border-slate-100 shadow-sm p-6 text-left hover:-translate-y-0.5 transition-all">
          <div className="w-14 h-14 rounded-2xl bg-yellow-100 flex items-center justify-center mb-3"><Megaphone className="w-7 h-7 text-yellow-600" /></div>
          <div className="text-xl font-extrabold text-slate-900">📢 Publiko Punë</div>
          <p className="text-sm text-slate-500 mt-0.5">Po kërkoj punëtor</p>
        </button>
      </div>
    </div>
  );
}
